import React from 'react';
import PropTypes from 'prop-types';

import SmartImage from 'dpl/components/SmartImage';
import { isLessThanBreakpoint } from 'dpl/util/grid';
import SmartLink from 'dpl/components/SmartLink';

const IMAGE_DIMS = isLessThanBreakpoint('md')
  ? { width: '112px', height: '126px' }
  : { width: '192px', height: '126px' };

export default function BrowseAvailablePuppiesCard({
  header,
  subheader,
  url,
  photo
}) {
  return (
    <SmartLink
      className="BrowseAvailablePuppiesCard flex h-100 br4 overflow-hidden ba b--light-gray max-content items-center"
      to={url}
      target="_blank"
    >
      {photo?.photo_url && (
        <SmartImage
          Tag="div"
          src={photo.photo_url}
          className="bg-center cover h-100 w-100"
          loadingClass="bg-light-gray"
          crop
          alt={photo?.alt_text}
          {...IMAGE_DIMS}
        />
      )}
      <div className="ph4 pv4">
        {header && (
          <h6 className="fw-medium f3 f4-md mb1 lh-normal pre-wrap">
            {header}
          </h6>
        )}
        {subheader && <p className="dark-silver font-16-mobile">{subheader}</p>}
      </div>
    </SmartLink>
  );
}

BrowseAvailablePuppiesCard.propTypes = {
  header: PropTypes.string.isRequired,
  subheader: PropTypes.string,
  url: PropTypes.string.isRequired,
  photo: PropTypes.shape({
    photo_url: PropTypes.string,
    source_url: PropTypes.string,
    source_name: PropTypes.string,
    alt_text: PropTypes.string
  })
};

BrowseAvailablePuppiesCard.defaultProps = {
  subheader: null,
  photo: null
};
